import { render } from "./SummaryMetricsSummaryTable.vue?vue&type=template&id=babb46e8&scoped=true&lang=pug"
import script from "./SummaryMetricsSummaryTable.vue?vue&type=script&lang=js"
export * from "./SummaryMetricsSummaryTable.vue?vue&type=script&lang=js"

import "./SummaryMetricsSummaryTable.vue?vue&type=style&index=0&id=babb46e8&lang=scss"
import "./SummaryMetricsSummaryTable.vue?vue&type=style&index=1&id=babb46e8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-babb46e8"]])

export default __exports__